var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VCard',[_c('VCardText',[_c('DeliveryTime',{ref:"deliveryTime",attrs:{"title":_vm.$t('company.form.deliveryTime'),"initial-values":_vm.initialValues}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }